import React from 'react';

const faqs = [
  {
    category: '🔧 General FAQs',
    items: [
      {
        question: '1. What is Cast to TV and how does it work?',
        answer:
          'Cast to TV lets you wirelessly stream videos, photos, and music from your Android phone or tablet to a smart TV or any casting-enabled display using Wi-Fi.',
      },
      {
        question: '2. What is Screen Mirroring?',
        answer:
          'Screen Mirroring allows you to display your phone’s entire screen (apps, games, UI, etc.) on your TV in real-time.',
      },
      {
        question: '3. Do I need a smart TV to use the TV Cast Pro app?',
        answer:
          'Yes, your TV must either be a smart TV with built-in casting (like Chromecast, Miracast, or DLNA support) or be connected to a casting device (like a Chromecast dongle, Fire TV Stick, etc.).',
      },
    ],
  },
  {
    category: '📲 Compatibility FAQs',
    items: [
      {
        question: '4. Which TVs are supported by the TV Cast Pro?',
        answer: (
          <ul className="list-disc pl-5">
            <li>Google Chromecast</li>
            <li>Amazon Fire TV</li>
            <li>Samsung Smart TVs</li>
            <li>LG Smart TVs</li>
            <li>Android TVs</li>
            <li>Sony Bravia and others with Miracast/Chromecast support</li>
          </ul>
        ),
      },
      {
        question: '5. Does it work with iOS or only Android?',
        answer: 'This version of the app is designed specifically for Android devices only.',
      },
      {
        question: '6. Is the internet required for screen casting or mirroring?',
        answer: 'Yes, both your Android device and your TV must be connected to the same Wi-Fi network for successful casting or mirroring.',
      },
    ],
  },
  {
    category: '🎥 Media Casting FAQs',
    items: [
      {
        question: '7. What type of media can I cast?',
        answer: 'You can cast local videos, photos, and audio files stored on your device.',
      },
      {
        question: '8. Can I cast videos from apps like YouTube or Netflix?',
        answer:
          'Due to third-party app restrictions, direct casting from some apps may not be supported. For apps with built-in cast buttons, use those directly.',
      },
    ],
  },
  {
    category: '🖥️ Screen Mirroring FAQs',
    items: [
      {
        question: '9. Why is there a delay or lag during screen mirroring?',
        answer:
          'Slight delays can occur due to network speed or TV processing. Please ensure a strong Wi-Fi connection and also close background apps for better performance.',
      },
      {
        question: '10. Can I play mobile games using screen mirroring?',
        answer:
          'Yes, but note that fast-paced games may experience input lag depending on your Wi-Fi speed and TV latency.',
      },
    ],
  },
  {
    category: '❗ Troubleshooting FAQs',
    items: [
      {
        question: '11. Why can\'t my phone find the TV?',
        answer: (
          <ul className="list-disc pl-5">
            <li>Both devices are on the same Wi-Fi network</li>
            <li>The TV or casting device is powered on</li>
            <li>Casting is enabled on the TV</li>
            <li>Your phone supports Miracast or Chromecast protocols</li>
          </ul>
        ),
      },
      {
        question: '12. The video is not playing or stuck—what should I do?',
        answer: (
          <ul className="list-disc pl-5">
            <li>Check internet connectivity</li>
            <li>Reboot both the phone and the TV</li>
            <li>Ensure the video format is supported</li>
            <li>Clear the app cache and try again</li>
          </ul>
        ),
      },
    ],
  },
  {
    category: '🔒 Security & Privacy FAQs',
    items: [
      {
        question: '13. Is screen mirroring secure?',
        answer: 'Yes, the app only connects over your local Wi-Fi. No data is sent to external servers.',
      },
      {
        question: '14. Does the app record or store my screen or media?',
        answer: 'No. The app does not record or store any content. It only facilitates real-time casting.',
      },
    ],
  },
];

const CastToTVFAQs = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Cast to TV FAQs</h1>
      <p className="mb-6">
        If you have any queries for our TV Cast Pro or face any difficulty using it, please write to us at{' '}
        <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 underline">
          feedback@appspacesolutions.in
        </a>.
      </p>
      {faqs.map((section, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-xl font-semibold mb-3">{section.category}</h2>
          <ul className="space-y-4">
            {section.items.map((item, i) => (
              <li key={i}>
                <p className="font-bold">{item.question}</p>
                <div className="text-gray-700">{item.answer}</div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default CastToTVFAQs;
